import { http } from "@/utils/http";

export type UserResult = {
  code: number;
  text: string;
  data: {
    id: string;
    avatar?: string;
    /** 用户账号 */
    userCode: string;
    /** 用户名 */
    userName: string;
    /** 用户类型 */
    accountType: string;
    /** 公司名 */
    companyName: string;
    /** 公司 ID */
    companyId: string;
    /** 当前登陆用户的角色 */
    roles: string[];
    /** `token` */
    accessToken: string;
    /** 用于调用刷新`accessToken`的接口时所需的`token` */
    refreshToken: string;
    /** `accessToken`的过期时间（格式'xxxx/xx/xx xx:xx:xx'） */
    expires: number;
  };
};

export type RefreshTokenResult = {
  code: number;
  text: string;
  data: {
    /** `token` */
    accessToken: string;
    /** 用于调用刷新`accessToken`的接口时所需的`token` */
    refreshToken: string;
    /** `accessToken`的过期时间（格式'xxxx/xx/xx xx:xx:xx'） */
    expires: number;
  };
};

/** 登录 */
export const getLogin = (data?: object) => {
  return http.request<UserResult>("post", "/user/login", { data });
};

/** 刷新`token` */
export const refreshTokenApi = (data?: object) => {
  return http.request<RefreshTokenResult>("post", "/user/refreshToken", {
    data
  });
};

/** 修改密码 */
export const updatePassword = (data: object) => {
  return http.request<BaseResult>("post", `/user/updateUserPassword`, {
    data
  });
};
